import React from "react";
import { champPath } from "../misc/Static";
import Augment from "../images/Augment";
import Champ from "../images/Champ";
import Elo from "../misc/Elo";
import Item from "../images/Item";
import { Link } from "react-router-dom";
import styles from "./MatchArenaRow.module.css";

export const MatchArenaRow = ({ match, calc, region, p, width }) => {
  const tier = match.tier[p].toLowerCase();
  const division = match.division[p];
  return (
    <>
      <div className={styles[width]}>
        <div className={styles.rank}>
          <div>{["1st", "2nd", "3rd", "4th","5th","6th","7th","8th"][match.placement[p] - 1]}</div>
        </div>
        <div className={styles.champ}>
          <a
            href={
              "https://lolalytics.com/lol/" +
              champPath(match.champion[p]) +
              "/build/"
            }
          >
            <Champ type="champ50b" id={match.champion[p]} />
          </a>
          <div>{match.champLevel[p]}</div>
        </div>
        <div className={styles.augment}>
          <div>
            {[0, 1].map((x) => (
              <div key={x}>
                {[0, 1].map((y) => (
                  <div key={y}>
                    <Augment
                      augment={match[`augment${x * 2 + y + 1}`][p]}
                      size="24"
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.summoner}>
          <Link to={match.pathName[p]}>
            <div>{match.summonerName[p]}</div>
          </Link>
        </div>
        {width === "xsmall" && <Elo tier={tier} division={division} />}
        {width !== "xsmall" && (
          <div className={styles.tier}>
            <img
              src={`https://cdn5.xdx.gg/emblem32/${tier}.webp`}
              srcSet={`https://cdn5.xdx.gg/emblem32/${tier}.webp 32w,
              https://cdn5.xdx.gg/emblem64/${tier}.webp 64w,
              https://cdn5.xdx.gg/emblem96/${tier}.webp 96w`}
              width="32"
              height="32"
              alt={match.tier[p]}
            />
            <div>
              {tier} {division}
            </div>
          </div>
        )}
        <div className={styles.items}>
          {match.items[p].map((item, i) => (
            <React.Fragment key={"item" + i}>
              {item === 0 && <div className={styles.placeholder}></div>}
              {item > 0 && <Item type="item24r" id={item} />}
            </React.Fragment>
          ))}
        </div>
        <div className={styles.kda}>
          <div>{calc.kda[p]}</div>
          <div>
            <span>{match.kills[p]}</span>/<span>{match.deaths[p]}</span>/
            <span>{match.assists[p]}</span>
          </div>
        </div>
        <div className={styles.damage}>
          {match.totalDamageDealtToChampions[p].toLocaleString()}
          <div></div>
          <div
            style={{
              width: `${
                (match.totalDamageDealtToChampions[p] / calc.maxDamage) * 100
              }%`,
            }}
          ></div>
        </div>
        <div className={styles.gold}>
          {Math.round(match.goldEarned[p] / 1000)}K
        </div>
      </div>
    </>
  );
};
export default MatchArenaRow;
